import { render, staticRenderFns } from "./orgGuide.vue?vue&type=template&id=5a4383ce&scoped=true&"
import script from "./orgGuide.vue?vue&type=script&lang=js&"
export * from "./orgGuide.vue?vue&type=script&lang=js&"
import style0 from "./orgGuide.vue?vue&type=style&index=0&lang=css&"
import style1 from "./orgGuide.vue?vue&type=style&index=1&id=5a4383ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4383ce",
  null
  
)

export default component.exports